<template>
  <Page :title="$t('disputeInfo.title')" v-if="isLoggedIn">
    <template v-slot:default>
      <wizard-navigation
        :current-step="currentStep"
        :max-steps="3"
        :next-button-text="$t('next')"
        :back-button-text="$t('back')"
        :finish-button-text="$t('next')"
        :is-next-button-disabled="nextStepDisabled"
        @nextStep="nextStep"
        @previousStep="previousStep">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title"><span class="icon icon-checkmark-circle" /> {{currentStep}} {{$t('disputeInfo.step')}}</h5>
            <div class="card-text card-centered">
              <span v-if="currentStep === 1" v-html="$t('disputeInfo.firstText')" />
              <span v-if="currentStep === 2" v-html="$t('disputeInfo.secondText')" />
              <div v-if="currentStep === 3">
                <span> {{ $t('disputeInfo.thirdText') }} </span>
                <div class="row justify-content-center mt-5">
                  <input
                    name="agreement"
                    id="agreement"
                    type="checkbox"
                    class="agreement"
                    @click="setDisabled($event)"
                  >
                  <label for="agreement" class="agreement-label"> {{ $t('disputeInfo.agreement') }} </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </wizard-navigation>
    </template>
  </Page>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import Page from './Page';
import WizardNavigation from '../components/WizardNavigation';

export default {
  components: {
    Page,
    WizardNavigation,
  },
  props: {
    isPrivate: Boolean,
  },
  data: () => ({
    currentStep: 1,
    nextStepDisabled: false,
  }),
  computed: {
    ...mapGetters('session', ['isLoggedIn']),
  },
  created() {
    if (!this.isLoggedIn) {
      this.$router.push({ name: `home-${this.$i18n.locale}`, params: { lang: this.$i18n.locale } });
    }
  },
  methods: {
    ...mapActions('app', ['sendStep']),

    nextStep() {
      this.sendStep({ step: this.currentStep });
      if (this.currentStep === 3) {
        if (this.isPrivate) {
          this.$router.push({ name: `disputePrivate-${this.$i18n.locale}`, params: { lang: this.$i18n.locale } });
        } else {
          this.$router.push({ name: `dispute-${this.$i18n.locale}`, params: { lang: this.$i18n.locale } });
        }
        return;
      }
      this.currentStep += 1;
      this.nextStepDisabled = this.currentStep === 3;
    },
    previousStep() {
      this.currentStep -= 1;
    },
    setDisabled(event) {
      this.nextStepDisabled = !event.target.checked;
    },
  },
};
</script>
<style scoped>
  .card-text {
    font-size: 1.1rem;
  }
  .agreement-label {
    font-size: large;
    text-align: center;
  }
  .agreement {
    height: 20px;
    width: 20px;
    margin-right: 1%;
  }
  @media (min-width: 575px) {
    .card-centered {
      margin-left: 20%;
      margin-right: 20%;
    }
  }
</style>
